module.exports = __webpack_public_path__ + "media/images/d_research_companies-5070b0d0954f69940151ffe20de7ad8d.svg";